import {
	conflictCheckResponseSchema,
	generatePreviewResponseSchema,
	generateResponseSchema,
	paginatedSeasonsSchema,
} from "../../schemas/training";
import { fetchApi, fetchVoid } from "../internal";

export const seasons = {
	checkConflicts: (clubId: string, seasonId: string, data: unknown) =>
		fetchApi(
			`/clubs/${clubId}/training/seasons/${seasonId}/conflicts`,
			conflictCheckResponseSchema,
			{ body: JSON.stringify(data), method: "POST" },
		),
	create: (clubId: string, data: unknown) =>
		fetchApi(`/clubs/${clubId}/training/seasons`, paginatedSeasonsSchema.shape.items.element, {
			body: JSON.stringify(data),
			method: "POST",
		}),
	delete: (clubId: string, seasonId: string) =>
		fetchVoid(`/clubs/${clubId}/training/seasons/${seasonId}`, {
			method: "DELETE",
		}),
	duplicate: (clubId: string, seasonId: string, data: unknown) =>
		fetchApi(
			`/clubs/${clubId}/training/seasons/${seasonId}/duplicate`,
			paginatedSeasonsSchema.shape.items.element,
			{ body: JSON.stringify(data), method: "POST" },
		),
	finalize: (clubId: string, seasonId: string) =>
		fetchApi(
			`/clubs/${clubId}/training/seasons/${seasonId}/finalize`,
			paginatedSeasonsSchema.shape.items.element,
			{ method: "POST" },
		),
	generate: (clubId: string, seasonId: string) =>
		fetchApi(`/clubs/${clubId}/training/seasons/${seasonId}/sessions`, generateResponseSchema, {
			method: "POST",
		}),
	get: (clubId: string, seasonId: string) =>
		fetchApi(
			`/clubs/${clubId}/training/seasons/${seasonId}`,
			paginatedSeasonsSchema.shape.items.element,
		),
	list: (clubId: string, params?: { status?: string }) => {
		const searchParams = new URLSearchParams();
		if (params?.status) searchParams.set("status", params.status);
		const qs = searchParams.toString();
		return fetchApi(
			`/clubs/${clubId}/training/seasons${qs ? `?${qs}` : ""}`,
			paginatedSeasonsSchema,
		);
	},
	preview: (clubId: string, seasonId: string) =>
		fetchApi(
			`/clubs/${clubId}/training/seasons/${seasonId}/sessions/preview`,
			generatePreviewResponseSchema,
			{ method: "POST" },
		),
	update: (clubId: string, seasonId: string, data: unknown) =>
		fetchApi(
			`/clubs/${clubId}/training/seasons/${seasonId}`,
			paginatedSeasonsSchema.shape.items.element,
			{ body: JSON.stringify(data), method: "PUT" },
		),
};
